import axios, { AxiosError, AxiosResponse } from "axios";
import { API_BASE_URL } from "./constants";
import {
  AUTH_COOKIE_NAME,
  LANG_COOKIE_NAME,
  getCookie,
  logout,
} from "./auth.util";
import { enqueueSnackbar } from "notistack";

axios.defaults.baseURL = API_BASE_URL;

axios.interceptors.request.use(async function (config) {
  const token = getCookie(AUTH_COOKIE_NAME);
  const langToken = getCookie(LANG_COOKIE_NAME);
  if (!config.url?.includes("s3.us-east-2.amazonaws.com")) {
    config.headers["lang"] = langToken;
    config.headers["platform"] = `web`;
  }
  if (token && !config.url?.includes("s3.us-east-2.amazonaws.com")) {
    config.headers["Authorization"] = `Bearer  ${token}`;
  }
  return config;
});

axios.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    const token = getCookie(AUTH_COOKIE_NAME);
    if (token && error.response?.status === 401) {
      logout();
      enqueueSnackbar("Session expired. Please log in again.", {
        variant: "warning",
      });
      // window.location.href = "/login";
    }

    // Extract backend error message and attach it to error object
    if (error.response?.data) {
      const responseData = error.response.data as any;
      if (responseData.message) {
        error.message = responseData.message;
      }
    }

    return Promise.reject(error);
  }
);
